import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from '../../../base.service';
import { BehaviorSubject } from 'rxjs';
import { UserExtraInfoModel } from '../users/users.service';

export class InvoiceDetailsModel {
  id!: number;
  code!: string;
  licenseProduct_Id!: number;
  partner_Id!: number;
  owner_Id!: number;
  o_CompanyName!: string;
  o_IsBillToClient!: boolean;
  o_PPkg_DiscountPercent!: number;
  o_PPkg_IsActive!: boolean;
  o_PPkg_Name!: string;
  o_PPkg_ServiceDiscountPercent!: number;
  srvDiscountAmount!: number;
  user_Id!: number;
  partnerName!: string;
  ownerName!: string;
  userName!: string;
  isNewFeature!: boolean;
  isPaid!: boolean;
  isRecurring!: boolean;
  docRefNo!: string;
  invoiceDate!: string;
  invoiceDueDate!: string;
  partnerDiscountRate!: number;
  serviceDiscountRate!: number;
  plD_Duration!: number;
  plD_ChargeDuration!: number;
  extraStores!: number;
  totalAmount!: number;
  totalTax!: number;
  discountAmount!: number;
  paymentDate!: string;
  transaction_Id!: null;
  recurring_Id!: null;
  remarks!: string;
  invoice_Details!: InvoiceDetail[];
  partnerExtraInfo!: UserExtraInfoModel;
  plan!: PlanInfo;
}
// "plan": {
//         "id": 1,
//         "planName": "NO PLAN",
//         "startDate": "2025-02-01T00:00:00+00:00",
//         "isActive": true,
//         "planDetail": []
//     },

class PlanInfo {
  id!: number;
  planName!: string;
  startDate!: string;
  isActive!: boolean;
  planDetail!: null;
}

class InvoiceExtraInfo {
  productInfo!: null;
  moduuleInfo!: null;
  featureInfo!: null;
  userName!: null;
  partnerName!: null;
}

class InvoiceDetail {
  id!: number;
  invoiceMaster_Id!: number;
  licenseFeature_Id!: number;
  productFeature_Id!: number;
  feature_Date_Start!: string;
  feature_Date_End!: string;
  rate!: number;
  price!: number;
  price_ExtraStore!: number;
  price_OneTime!: number;
  remarks!: string;
  productName!: string;
  featureName!: string;
  extraInfo!: ExtraInfo;
}

class ExtraInfo {
  productInfo!: null;
  moduuleInfo!: null;
  featureInfo!: FeatureInfo;
}

class FeatureInfo {
  id!: number;
  productModules_Id!: number;
  dependencyID!: number;
  isBase!: boolean;
  p_Product_ID!: number;
  p_ProductCode!: string;
  p_ProductName!: string;
  p_Module_ID!: number;
  p_ModuleCode!: string;
  p_ModuleName!: string;
  p_LicenseDuration!: null;
  featureCode!: string;
  featureName!: string;
  productEndDate!: string;
  price!: number;
  price_ExtraStore!: number;
  price_OneTime!: number;
  isActive!: boolean;
  isServiceItem!: boolean;
  trialPaymentType!: number;
  createdOnUTC!: string;
  updatedOnUTC!: string;
}

class ModuuleInfo {
  id!: number;
  products_Id!: number;
  p_ProductCode!: string;
  p_ProductName!: string;
  dependencyID!: number;
  moduleCode!: string;
  moduleName!: string;
  displayOrder!: number;
  isActive!: boolean;
  createdOnUTC!: string;
  updatedOnUTC!: string;
  featureList!: null;
}

class ProductInfo {
  id!: number;
  productCode!: string;
  productName!: string;
  productURL!: string;
  productImagePath!: string;
  productDOCPath!: string;
  licenseDurationType!: number;
  isCentralAllowed!: boolean;
  commitmentDuration!: number;
  cancellationRate!: number;
  graceDays!: number;
  displayOrder!: number;
  isActive!: boolean;
  createdOnUTC!: string;
  updatedOnUTC!: string;
  moduleList!: null;
}

export class MarkAsPaidModal {
  id!: number;
  isPaid: boolean = true;
  paymentDate!: string;
  remarks!: string;
}


      
@Injectable({
  providedIn: 'root'
})
export class InvoicedetailService {

  
  private storageUserKey = 'InvoiceData';
  private savedInvoiceData = localStorage.getItem(this.storageUserKey);
  private selectedInvoiceDatadataSource = new BehaviorSubject<any>(this.savedInvoiceData ? JSON.parse(this.savedInvoiceData) : null);
  selectedInvoiceData = this.selectedInvoiceDatadataSource.asObservable();
  selectedInvoiceDataUpdate(data: any) {
    this.selectedInvoiceDatadataSource.next(data);
    localStorage.setItem(this.storageUserKey, JSON.stringify(data));
  }

  constructor(private http: HttpClient, private BaseService: BaseService) { }

  MarkAsPaidData: MarkAsPaidModal = new MarkAsPaidModal();


  private getHeaders() {
    const token = localStorage.getItem('token');
    return new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
  }

  PayInvoice(data:any)
  {
    const headers = this.getHeaders();
    return this.http.post(this.BaseService.BASEURL + '/api/Payment/PayInvoice', data, {
      headers,
    });
  }

  
  CreateRecuring(data:any)
  {
    const headers = this.getHeaders();
    return this.http.post(this.BaseService.BASEURL + '/api/Payment/ChargeDrCrCard_Recurring', data, {
      headers,
    });
  }




  MarkInvoiceAsPaid(body: any) {
    const headers = this.getHeaders();
    return this.http.post(this.BaseService.BASEURL + '/api/Invoice/MarkInvoiceAsPaid', body, {
      headers,
    });
  }

  GetInvoiceDetailsById(id: number) {
    const headers = this.getHeaders();

      console.log('code', id);

    return this.http.get(this.BaseService.BASEURL + '/api/Invoice/GetByID_Code?code=' + id, {
      headers,
    });
  }

}

